import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACS_FollowUp = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACS_FollowUp' className='file-pdf-document'>
            <div className='file-template'>
                <table>
                    <tr>
                        <td className='w-750'> 
                            <span className='eleHeader'>Location</span>
                            <input type="checkbox" id="cbLocation_1" name="cbLocation" className='add-only' value="Home" /> Home &nbsp;
                            <input type="checkbox" id="cbLocation_2" name="cbLocation" className='add-only' value="Office" /> Office &nbsp;
                            <input type="checkbox" id="cbLocation_3" name="cbLocation" className='add-only' value="Other" /> Other:
                            <input type='text' id="txtLocation" name="txtLocation" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            PLEASE PLACE AN (X) BY SERVICE(S) BEING ORDERED FOR CONSUMER <strong> PHYSICIAN ORDER OF SERVICES </strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Service Name</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbServiceName_DiagnosticAssessment" name="cbServiceName" className='add-only' value="Diagnostic Assessment" /> Diagnostic Assessment
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbServiceName_PsychiatricTreatment" name="cbServiceName" className='add-only' value="Psychiatric Treatment" /> Psychiatric Treatment
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbServiceName_NursingAssessmentCare" name="cbServiceName" className='add-only' value="Nursing Assessment & Care" /> Nursing Assessment & Care
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> 
                            <input type="checkbox" id="cbServiceName_MedicationAdministration" name="cbServiceName" className='add-only' value="Medication Administration" /> Medication Administration
                        </td>
                        <td className='w-500'> 
                            <input type="checkbox" id="cbServiceName_TherapeuticInterventionsFromACE" name="cbServiceName" className='add-only' value="Therapeutic interventions from ACE" /> Therapeutic interventions from ACE
                        </td> 
                    </tr>
                </table>
                <h4>Vitals</h4>
                <table>
                    <tr>
                        <td className='w-125'> 
                            <span className='eleHeader'>B/P</span>
                            <input type='text' id="txtBP" name="txtBP" className='add-only' />
                        </td>
                        <td className='w-125'> 
                            <span className='eleHeader'>HR</span>
                            <input type='text' id="txtHR" name="txtHR" className='add-only' />
                        </td>
                        <td className='w-125'> 
                            <span className='eleHeader'>Temp</span>
                            <input type='text' id="txtTemp" name="txtTemp" className='add-only' />
                        </td>
                        <td className='w-125'> 
                            <span className='eleHeader'>Resp</span>
                            <input type='text' id="txtResp" name="txtResp" className='add-only' />
                        </td>
                        <td className='w-125'> 
                            <span className='eleHeader'>Height</span>
                            <input type='text' id="txtHeight" name="txtHeight" className='add-only' />
                        </td>
                        <td className='w-125'> 
                            <span className='eleHeader'>Weight</span>
                            <input type='text' id="txtWeight" name="txtWeight" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Identifying Information/HPI Summary</span>
                    <textarea id="txtSummary" name="txtSummary" className='add-only' rows={5} ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Current meds</span>
                    <textarea id="txtCurrentMeds" name="txtCurrentMeds" className='add-only' rows={5}></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Side Effects</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type="checkbox" id="cbSideEffects_1" name="cbSideEffects" className='add-only' value="Sleep Disturbances" /> Sleep Disturbances</td>
                        <td className='w-187'> <input type="checkbox" id="cbSideEffects_2" name="cbSideEffects" className='add-only' value="Sedation" /> Sedation</td>
                        <td className='w-187'> <input type="checkbox" id="cbSideEffects_3" name="cbSideEffects" className='add-only' value="Eating Disturbances" /> Eating Disturbances</td>
                        <td className='w-187'> <input type="checkbox" id="cbSideEffects_4" name="cbSideEffects" className='add-only' value="Tics" /> Tics</td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type="checkbox" id="cbSideEffects_5" name="cbSideEffects" className='add-only' value="Muscle Stiffness" /> Muscle Stiffness</td>
                        <td className='w-187'> <input type="checkbox" id="cbSideEffects_6" name="cbSideEffects" className='add-only' value="Dystonia" /> Dystonia</td>
                        <td className='w-187'> <input type="checkbox" id="cbSideEffects_7" name="cbSideEffects" className='add-only' value="Akasthesia" /> Akasthesia</td>
                        <td className='w-187'> <input type="checkbox" id="cbSideEffects_8" name="cbSideEffects" className='add-only' value="Dizziness" /> Dizziness</td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type="checkbox" id="cbSideEffects_9" name="cbSideEffects" className='add-only' value="Nausea" /> Nausea</td>
                        <td className='w-187'> <input type="checkbox" id="cbSideEffects_10" name="cbSideEffects" className='add-only' value="Tremor" /> Tremor</td>
                        <td className='w-187'> <input type="checkbox" id="cbSideEffects_11" name="cbSideEffects" className='add-only' value="Rash" /> Rash</td>
                        <td className='w-187'> <input type="checkbox" id="cbSideEffects_12" name="cbSideEffects" className='add-only' value="Diarrhea" /> Diarrhea</td>
                         
                    </tr>
                    <tr> 
                        <td className='w-187'> <input type="checkbox" id="cbSideEffects_13" name="cbSideEffects" className='add-only' value="Galactorrhea" /> Galactorrhea</td>
                        <td className='w-187'> <input type="checkbox" id="cbSideEffects_14" name="cbSideEffects" className='add-only' value="Gynecomastia" /> Gynecomastia</td>
                    </tr> 
                    <tr>
                        <td className='w-375'> <input type="checkbox" id="cbSideEffects_15" name="cbSideEffects" className='add-only' value="Other" /> Other:
                            <input type='text' id="txtSideEffects_Other" name="txtSideEffects_Other" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Allergic to</span>
                    <input type="checkbox" id="cbAllergicTo_KNDA" name="cbAllergicTo" className='add-only' value="KNDA" /> KNDA<br />
                    <textarea id="txtAllergicTo" name="txtAllergicTo" className='add-only' rows={5}></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Mood</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_euthymic" name="cbMood" className='add-only' value="euthymic" /> Euthymic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_dysthymic" name="cbMood" className='add-only' value="dysthymic" /> Dysthymic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_agitated" name="cbMood" className='add-only' value="agitated" /> Agitated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMood_Other" name="cbMood" className='add-only' value="Other" /> Other:
                            <input type='text' id="txtMoodOther" name="txtMoodOther" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Affect</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_Normal" name="cbAffect" className='add-only' value="Normal" /> Normal
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_Labile" name="cbAffect" className='add-only' value="Labile" /> Labile
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_ConstrictedOrBlunted" name="cbAffect" className='add-only' value="Constricted/Blunted" /> Constricted/Blunted
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbAffect_Other" name="cbAffect" className='add-only' value="Other" /> Other:
                            <input type='text' id="txtAffectOther" name="txtAffectOther" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Motor</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMotor_wnl" name="cbMotor" className='add-only' value="wnl" /> Wnl
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMotor_HyperOrAgitated" name="cbMotor" className='add-only' value="hyper/agitated" /> Hyper/agitated
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMotor_Slowed" name="cbMotor" className='add-only' value="slowed" /> Slowed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMotor_Other" name="cbMotor" className='add-only' value="Other" /> Other:
                            <input type='text' id="txtMotorOther" name="txtMotorOther" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Speech</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_wnl" name="cbSpeech" className='add-only' value="wnl" /> Wnl
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_pressured" name="cbSpeech" className='add-only' value="pressured" /> Pressured
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_dysfluent" name="cbSpeech" className='add-only' value="dysfluent" /> Dysfluent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_NonVerbal" name="cbSpeech" className='add-only' value="non-verbal" /> Non-verbal
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" id="cbSpeech_Other" name="cbSpeech" className='add-only' value="Other" /> Other:
                            <input type='text' id="txtSpeechOther" name="txtSpeechOther" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>TP</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTp_GoalDirected" name="cbTp" className='add-only' value="goal directed" /> Goal directed
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTp_Loose" name="cbTp" className='add-only' value="Loose" /> Loose
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTp_FOISparse" name="cbTp" className='add-only' value="FOI sparse" /> FOI sparse
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTP_Other" name="cbTp" className='add-only' value="Other" /> Other:
                            <input type='text' id="txtTPOther" name="txtTPOther" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>TC</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTc_WNL" name="cbTc" className='add-only' value="WNL" /> WNL
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTc_AH" name="cbTc" className='add-only' value="AH" /> AH
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTc_VH" name="cbTc" className='add-only' value="VH" /> VH
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTc_HI" name="cbTc" className='add-only' value="HI" /> HI
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTc_delusions" name="cbTc" className='add-only' value="delusions" /> Delusions:
                            <input type='text' id="txtdelusions" name="txtdelusions" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTc_obsessions" name="cbTc" className='add-only' value="obsessions" /> Obsessions:
                            <input type='text' id="txtobsessions" name="txtobsessions" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTc_SI" name="cbTc" className='add-only' value="SI" /> SI:
                            <input type='text' id="txtSI" name="txtSI" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" id="cbTC_Other" name="cbTc" className='add-only' value="Other" /> Other:
                            <input type='text' id="txtTCOther" name="txtTCOther" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Insight/Judgment</span>
                    <select id="ddlJudgment" name="ddlJudgment" className='add-only'>
                        <option value="NA"></option>
                        <option value="good">Good</option>
                        <option value="fair">Fair</option>
                        <option value="poor">Poor</option>
                    </select>
                </p>
                <p>
                    <span className='eleHeader'>Labs/Forms</span>
                    <textarea id="txtLabs" name="txtLabs" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>A/P</span>
                    <textarea id="txtAp" name="txtAp" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Diagnosis</span>
                    <textarea id="txtDiagnosis" name="txtDiagnosis" className='add-only'></textarea> 
                </p>  

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recommendation</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRecommendation_ContinueCurrentMeds" name="cbRecommendation" className='add-only' value="Continue current meds" /> Continue current meds</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRecommendation_SameDose" name="cbRecommendation" className='add-only' value="same dose" /> Same dose</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRecommendation_DifferentDose" name="cbRecommendation" className='add-only' value="different dose" /> Different dose</td>
                    </tr>
                    <tr>
                        <td className='w-250'> 
                            <input type="checkbox" id="cbRecommendation_ConsentObtained" name="cbRecommendation" className='add-only' value="consent obtained" /> Consent obtained
                            <input type='text' id="txtConsentObtained" name="txtConsentObtained" className='add-only' />
                        </td>
                        <td className='w-250'> 
                            <input type="checkbox" id="cbRecommendation_ADHDChecklistProv" name="cbRecommendation" className='add-only' value="ADHD Checklist Provided" /> ADHD Checklist Provided
                        </td>
                        <td className='w-250'> 
                            <input type="checkbox" id="cbRecommendation_ADHDChecklist" name="cbRecommendation" className='add-only' value="ADHD Checklist Completed/Returned" /> ADHD Checklist Completed/Returned
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbRecommendation_Other" name="cbRecommendation" className='add-only' value="Other" /> Other:
                            <input type='text' id="txtRecommendation_Other" name="txtRecommendation_Other" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbRecommendation_DifferentMeds" name="cbRecommendation" className='add-only' value="different meds" /> Different meds<br />
                            <textarea id="txtRecommendation_DifferentMeds" name="txtRecommendation_DifferentMeds" className='add-only' rows={5}></textarea>
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>RTC</span>
                    <select id="ddlRTC" name="ddlRTC" className='add-only'>
                        <option value="N/A"></option>
                        <option value="1 Week">1 Week</option>
                        <option value="2 Weeks">2 Weeks</option>
                        <option value="3 Weeks">3 Weeks</option>
                        <option value="4 Weeks">4 Weeks</option>
                        <option value="5 Weeks">5 Weeks</option>
                        <option value="6 Weeks">6 Weeks</option>
                        <option value="7 Weeks">7 Weeks</option>
                        <option value="8 Weeks">8 Weeks</option>
                        <option value="12 Weeks">12 Weeks</option>
                    </select>
                </p>
                <p>
                    <span className='eleHeader'>STATEMENT</span>
                    <input type="checkbox" id="cbStatement" name="cbStatement" className='add-only' value="statement" /> I am supervising physician to Nurse Practitioner and have discussed patient's case and agree with above-written note.
                </p>
                <table>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Physician Signature/Title</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Please Type/Print Name and Title</td>
                        <td className='small w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Co-signer Signature/Title</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Please Type/Print Name and Title</td>
                        <td className='small w-150'>&nbsp;</td>
                    </tr>

                </table>









            </div>
        </form>

    )
}    